var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isSizeAdvisorRunning
    ? _c(
        "div",
        [
          _c("div", { staticClass: "size-advisor__overlay" }),
          _vm._v(" "),
          _c("div", {
            staticClass: "size-advisor--is-running",
            attrs: { id: "sizeadv-ui", "data-analytics_available_call": "0" },
          }),
          _vm._v(" "),
          _vm.loading && _vm.isSizeAdvisorRunning
            ? _c("rb-loader-glasses", { staticClass: "size-advisor__spinner" })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }